"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("./Checkbox")); // eslint-disable-line sort-imports


var CheckboxGroup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CheckboxGroup, _Component);

  function CheckboxGroup() {
    (0, _classCallCheck2.default)(this, CheckboxGroup);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CheckboxGroup).apply(this, arguments));
  }

  (0, _createClass2.default)(CheckboxGroup, [{
    key: "renderCheckbox",
    value: function renderCheckbox(props) {
      var _this$props = this.props,
          checkboxWrapClassName = _this$props.checkboxWrapClassName,
          checkboxWrapTag = _this$props.checkboxWrapTag;
      var value = props.value,
          other = (0, _objectWithoutProperties2.default)(props, ["value"]);

      var checkbox = _react.default.createElement(_Checkbox.default, (0, _extends2.default)({}, other, {
        key: value,
        value: value
      }));

      if (checkboxWrapTag) {
        var WrapTag = checkboxWrapTag;
        return _react.default.createElement(WrapTag, {
          className: checkboxWrapClassName
        }, checkbox);
      }

      return checkbox;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          checkboxWrapClassName = _this$props2.checkboxWrapClassName,
          checkboxWrapTag = _this$props2.checkboxWrapTag,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "checkboxWrapClassName", "checkboxWrapTag"]);

      var options = _react.default.Children.map(children, function (option) {
        return _this.renderCheckbox(option.props);
      }, this);

      return _react.default.createElement("div", (0, _extends2.default)({}, other, {
        className: className
      }), options);
    }
  }]);
  return CheckboxGroup;
}(_react.Component);

(0, _defineProperty2.default)(CheckboxGroup, "propTypes", {
  children: _propTypes.default.node.isRequired,
  checkboxWrapClassName: _propTypes.default.string,
  checkboxWrapTag: _propTypes.default.string,
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(CheckboxGroup, "defaultProps", {
  checkboxWrapClassName: null,
  checkboxWrapTag: null,
  className: null
});
var _default = CheckboxGroup;
exports.default = _default;